import { IDetailCellRendererParams } from "ag-grid-community";
import { openRowChildrenCount as openRowChildrenCountAtom } from "./LineageTable";
import clsx from "clsx";
import { ACCOUNT_TAXONOMY } from "@/entities/Labeling/Account.model";
import { useSetAtom } from "jotai";
import { useMemo } from "react";
import { HydratedLineagedValue } from "@/entities/Finance/Finance.model";
import { investmentMemoGridTheme } from "./agGridTheme";

export const useInnerTableParams = () => {
    const setOpenRowChildrenCount = useSetAtom(openRowChildrenCountAtom);

    return useMemo(
        () =>
            ({
                detailGridOptions: {
                    theme: investmentMemoGridTheme,
                    columnDefs: [
                        {
                            field: "name",
                            headerName: "Account Name",
                            width: 260,
                        },
                        {
                            field: "label",
                            headerName: "Account Label",
                            resizable: false,
                            flex: 1,
                            cellRenderer: (params) => {
                                const label = params.data.label;
                                const taxonomy = ACCOUNT_TAXONOMY[label];
                                const color = taxonomy?.color || "#10B981";

                                return (
                                    <div
                                        className={clsx(
                                            "text-color body-s",
                                            "flex h-full items-center gap-3 rounded-lg",
                                            "bg-transparent",
                                        )}
                                    >
                                        <div
                                            className="size-2 shrink-0 rounded-full"
                                            style={{ backgroundColor: color }}
                                        />

                                        <p className="body-s text-left">
                                            {taxonomy?.name || label}
                                        </p>
                                    </div>
                                );
                            },
                        },
                        {
                            field: "value",
                            headerName: "",
                            resizable: false,
                            pinned: "right",
                            valueFormatter: ({ value }) => {
                                return value
                                    ? new Intl.NumberFormat("en-US", {
                                          style: "currency",
                                          currency: "USD",
                                      }).format(value)
                                    : "";
                            },
                        },
                    ],

                    detailRowAutoHeight: true,
                    suppressRowHoverHighlight: true,
                },
                getDetailRowData: (params) => {
                    console.log(params.data);
                    params.successCallback(params.data.accounts);
                },
            }) as IDetailCellRendererParams<HydratedLineagedValue>,
        [setOpenRowChildrenCount],
    );
};
